import React from 'react';
import BackButton from '../components/BackButton';
import ArchitectureOfAccountability from '../components/ArchitectureOfAccountability';

function ArchitectureOfAccountabilityPage() {
  return (
    <>
      <BackButton />
      <ArchitectureOfAccountability />
    </>
  );
}

export default ArchitectureOfAccountabilityPage;
